import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ExternalLink, Palette, Type, Image, Layers } from 'lucide-react';

export const CanvaTips = () => {
  return (
    <Card className="bg-gradient-to-br from-purple-50 to-pink-50 border-purple-100">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg text-purple-900">
          <Palette className="w-5 h-5" />
          Want More Design Control?
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-purple-800">
          Download your template and open it in Canva for full design customization:
        </p>

        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Type className="w-4 h-4 text-purple-600" />
            </div>
            <div>
              <p className="font-medium text-purple-900 text-sm">Custom Typography</p>
              <p className="text-xs text-purple-700">Change fonts, sizes, and text styles</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Image className="w-4 h-4 text-purple-600" />
            </div>
            <div>
              <p className="font-medium text-purple-900 text-sm">Add Graphics</p>
              <p className="text-xs text-purple-700">Insert photos, icons, and illustrations</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Layers className="w-4 h-4 text-purple-600" />
            </div>
            <div>
              <p className="font-medium text-purple-900 text-sm">Professional Layouts</p>
              <p className="text-xs text-purple-700">Use Canva's templates and design tools</p>
            </div>
          </div>
        </div>

        <div className="pt-2">
          <p className="text-xs text-purple-700 mb-3">
            <strong>How to:</strong> Download your template as DOCX → Go to canva.com → Click "Create a design" → Upload your document
          </p>
          
          <Button
            variant="outline"
            size="sm"
            className="w-full bg-white border-purple-200 text-purple-700 hover:bg-purple-50 hover:text-purple-800"
            onClick={() => window.open('https://www.canva.com/create/documents/', '_blank')}
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Open Canva
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
